import { FormNumberField } from '~/modules/common/components';
import { withReadOnlyNoValue } from './withReadOnlyNoValue';

export default withReadOnlyNoValue(FormNumberField);
